import React, { useState } from 'react';
import { Box, ButtonBase, Menu, MenuItem } from '@material-ui/core';

import {
  ArrowNarrowDown,
  ArrowNarrowUp,
  CheckIcon,
  DropdownIcon,
} from '../../../../../../assets/icons';

import './SortByFilter.scss';
import { SORT_FIELDS } from '../../../Utilities/Utilities';

export default function SortByFilterComponent({ filter, setFilter }) {
  const [labelIcon, setLabelIcon] = useState('up');
  const [selectedOrder, setSelectedOrder] = useState('up');
  const [selectedField, setSelectedField] = useState(SORT_FIELDS[0].key);
  const [labelValue, setLabelValue] = useState(SORT_FIELDS[0].label);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFieldSelect = (key, label) => {
    setSelectedField(key);
    setLabelValue(label);
  };

  const handleOrderSelect = (order) => {
    setSelectedOrder(order);
    setLabelIcon(order);
  };

  const handleApplyFilter = () => {
    setFilter((prev) => ({
      ...prev,
      filterBy: selectedField,
      orderBy: selectedOrder === 'up' ? 2 : 1,
    }));
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonBase
        className='buttonSortWrapper'
        id='sorting-dropdown-btn'
        aria-controls={open ? 'sorting-dropdown-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleMenuOpen}
      >
        <div className='buttonContent'>
          <span className='buttonLabel'>Sort by</span>
          <span className='selectedValueWrapper'>
            <span className='selectedValue'>{labelValue}</span>
            {labelIcon === 'up' ? (
              <ArrowNarrowUp
                width='20'
                height='20'
                fill='#344054'
              />
            ) : (
              <ArrowNarrowDown
                width='20'
                height='20'
                fill='#344054'
              />
            )}
          </span>
        </div>
        <DropdownIcon
          width='20'
          height='20'
          fill='#344054'
        />
      </ButtonBase>

      <Menu
        id='custom-sort-menu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        getContentAnchorEl={null}
        elevation={0}
        PaperProps={{
          className: 'customMenu',
        }}
        MenuListProps={{
          className: 'customMenuList',
        }}
      >
        <Box className='menuSection'>
          <Box className='fieldScrollableList'>
            {SORT_FIELDS.map(({ key, label }) => (
              <MenuItem
                key={key}
                disableRipple
                selected={selectedField === key}
                onClick={() => handleFieldSelect(key, label)}
                className='customMenuItem'
              >
                <Box className='labelWrapper'>
                  <span className='label-text'>{label}</span>
                  {selectedField === key && (
                    <CheckIcon
                      width='16'
                      height='16'
                      fill='#8C734B'
                    />
                  )}
                </Box>
              </MenuItem>
            ))}
          </Box>
        </Box>

        <Box className='menuDivider' />

        <Box className='menuSection'>
          <MenuItem
            disableRipple
            selected={selectedOrder === 'down'}
            onClick={() => handleOrderSelect('down')}
            className='customMenuItem'
          >
            <Box className='labelWrapper'>
              <Box className='orderWrapper'>
                <ArrowNarrowDown
                  width='16'
                  height='16'
                  fill='#94969C'
                />
                <span>asc</span>
              </Box>
              {selectedOrder === 'down' && (
                <CheckIcon
                  width='16'
                  height='16'
                  fill='#7F6944'
                />
              )}
            </Box>
          </MenuItem>
          <MenuItem
            disableRipple
            selected={selectedOrder === 'up'}
            onClick={() => handleOrderSelect('up')}
            className='customMenuItem'
          >
            <Box className='labelWrapper'>
              <Box className='orderWrapper'>
                <ArrowNarrowUp
                  width='16'
                  height='16'
                  fill='#94969C'
                />
                <span>desc</span>
              </Box>
              {selectedOrder === 'up' && (
                <CheckIcon
                  width='16'
                  height='16'
                  fill='#7F6944'
                />
              )}
            </Box>
          </MenuItem>
        </Box>

        <Box className='menuDivider' />
        <Box className='actionsWrapper'>
          <ButtonBase
            className='btns theme-propx outlined'
            style={{ width: '105px' }}
            onClick={() => {
              setSelectedField(labelValue);
              setSelectedOrder(labelIcon);
              setAnchorEl(null);
            }}
          >
            Cancel
          </ButtonBase>
          <ButtonBase
            className='btns theme-propx solid'
            style={{ width: '105px' }}
            onClick={handleApplyFilter}
          >
            Apply
          </ButtonBase>
        </Box>
      </Menu>
    </>
  );
}
